const MONTH_NAMES = [
  "styczen",
  "luty",
  "marzec",
  "kwiecien",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpien",
  "wrzesien",
  "pazdziernik",
  "listopad",
  "grudzien",
];

function formatMonthValue(year, monthIndex) {
  return `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
}

function getSchoolYearStartYear(referenceDate = new Date()) {
  const monthIndex = referenceDate.getMonth();
  const year = referenceDate.getFullYear();

  return monthIndex >= 8 ? year : year - 1;
}

function buildSchoolYearMonthOptions(referenceDate = new Date()) {
  const currentYear = referenceDate.getFullYear();
  const currentMonthIndex = referenceDate.getMonth();
  const startYear = getSchoolYearStartYear(referenceDate);
  const options = [];

  let year = startYear;
  let monthIndex = 8;

  while (year < currentYear || (year === currentYear && monthIndex <= currentMonthIndex)) {
    options.push({
      value: formatMonthValue(year, monthIndex),
      text: `${MONTH_NAMES[monthIndex]} ${year}`,
    });

    monthIndex += 1;

    if (monthIndex === 12) {
      monthIndex = 0;
      year += 1;
    }
  }

  return options.reverse();
}

export default buildSchoolYearMonthOptions;
